import clsx from 'clsx';
import React from 'react';

const Divider = ({ padded = false }) => {
  return (
    <div
      className={clsx('cp_divider border-b border-gray-100', {
        'my-4': padded,
      })}
    ></div>
  );
};

export default Divider;
